class Industries {
    constructor(Utils) {
        this.industries = document.querySelectorAll('.industries-served .buttons button');

        if (!this.industries) {
            return;
        }

        this.init();
    }

    _closeAllIndustryInfo() {
        Array.prototype.forEach.call(this.industries, industry => {
            industry.classList.remove('open');
        });
    }

    _closeIndustryInfo(industry) {
        const closeBtn = industry.querySelector('.close');

        if (closeBtn) {

            closeBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                industry.classList.remove('open');
            });

            closeBtn.addEventListener('keyup', (e) => {
                e.stopPropagation();
            });
        }

    }

    // Fire event if user clicks or presses the enter button
    _enterEventHandler(element, callback) {
        const events = ['click', 'keyup'];

        Array.prototype.forEach.call(events, event => {
            element.addEventListener(event, function(e) {
                if (event !== 'click' && e.keyCode !== 13) {
                    return;
                }

                callback(e);
            });
        });
    }

    _openIndustryInfo(industry) {
        this._enterEventHandler(industry, e => {
            this._closeAllIndustryInfo();
            industry.classList.add('open');
        });
    }

    init() {
        Array.prototype.forEach.call(this.industries, industry => {
            this._openIndustryInfo(industry);
            this._closeIndustryInfo(industry);
        });
    }
}

export default Industries;